/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPlannedUnitCost } from '../fn/planned-unit-costs/create-planned-unit-cost';
import { CreatePlannedUnitCost$Params } from '../fn/planned-unit-costs/create-planned-unit-cost';
import { deletePlannedUnitCost } from '../fn/planned-unit-costs/delete-planned-unit-cost';
import { DeletePlannedUnitCost$Params } from '../fn/planned-unit-costs/delete-planned-unit-cost';
import { getPlannedUnitCost } from '../fn/planned-unit-costs/get-planned-unit-cost';
import { GetPlannedUnitCost$Params } from '../fn/planned-unit-costs/get-planned-unit-cost';
import { listPlannedUnitCosts } from '../fn/planned-unit-costs/list-planned-unit-costs';
import { ListPlannedUnitCosts$Params } from '../fn/planned-unit-costs/list-planned-unit-costs';
import { PlannedUnitCostDto } from '../models/planned-unit-cost-dto';
import { PlannedUnitCostDtoPage } from '../models/planned-unit-cost-dto-page';
import { updatePlannedUnitCost } from '../fn/planned-unit-costs/update-planned-unit-cost';
import { UpdatePlannedUnitCost$Params } from '../fn/planned-unit-costs/update-planned-unit-cost';

@Injectable({ providedIn: 'root' })
export class PlannedUnitCostsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listPlannedUnitCosts()` */
  static readonly ListPlannedUnitCostsPath = '/v0/plannedUnitCosts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPlannedUnitCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPlannedUnitCosts$Response(params?: ListPlannedUnitCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedUnitCostDtoPage>> {
    return listPlannedUnitCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listPlannedUnitCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPlannedUnitCosts(params?: ListPlannedUnitCosts$Params, context?: HttpContext): Observable<PlannedUnitCostDtoPage> {
    return this.listPlannedUnitCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedUnitCostDtoPage>): PlannedUnitCostDtoPage => r.body)
    );
  }

  /** Path part for operation `getPlannedUnitCost()` */
  static readonly GetPlannedUnitCostPath = '/v0/plannedUnitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlannedUnitCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedUnitCost$Response(params: GetPlannedUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedUnitCostDto>> {
    return getPlannedUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlannedUnitCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedUnitCost(params: GetPlannedUnitCost$Params, context?: HttpContext): Observable<PlannedUnitCostDto> {
    return this.getPlannedUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedUnitCostDto>): PlannedUnitCostDto => r.body)
    );
  }

  /** Path part for operation `updatePlannedUnitCost()` */
  static readonly UpdatePlannedUnitCostPath = '/v0/plannedUnitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlannedUnitCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePlannedUnitCost$Response(params: UpdatePlannedUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePlannedUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlannedUnitCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePlannedUnitCost(params: UpdatePlannedUnitCost$Params, context?: HttpContext): Observable<void> {
    return this.updatePlannedUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createPlannedUnitCost()` */
  static readonly CreatePlannedUnitCostPath = '/v0/plannedUnitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlannedUnitCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPlannedUnitCost$Response(params: CreatePlannedUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedUnitCostDto>> {
    return createPlannedUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlannedUnitCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPlannedUnitCost(params: CreatePlannedUnitCost$Params, context?: HttpContext): Observable<PlannedUnitCostDto> {
    return this.createPlannedUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedUnitCostDto>): PlannedUnitCostDto => r.body)
    );
  }

  /** Path part for operation `deletePlannedUnitCost()` */
  static readonly DeletePlannedUnitCostPath = '/v0/plannedUnitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePlannedUnitCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedUnitCost$Response(params: DeletePlannedUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePlannedUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePlannedUnitCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedUnitCost(params: DeletePlannedUnitCost$Params, context?: HttpContext): Observable<void> {
    return this.deletePlannedUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
